import React from 'react';

const LegacyTiktokIcon = () => {
  return (
    <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1253_2246)">
        <path
          d="M15.01 4.80078C14.0968 4.80078 13.2543 4.49828 12.5778 3.98797C11.8018 3.40297 11.2443 2.54484 11.0475 1.55578C10.9987 1.31141 10.9725 1.05922 10.97 0.800781H8.36154V7.92828L8.35841 11.8323C8.35841 12.8761 7.67872 13.7611 6.73654 14.0723C6.4631 14.1627 6.16779 14.2055 5.86029 14.1886C5.46779 14.167 5.09997 14.0486 4.78029 13.8573C4.09997 13.4505 3.63872 12.7123 3.62622 11.868C3.60654 10.5483 4.67341 9.47234 5.99216 9.47234C6.25247 9.47234 6.50247 9.51484 6.73654 9.59203V7.64391V6.94359C6.48966 6.90703 6.23841 6.88797 5.98435 6.88797C4.54091 6.88797 3.19091 7.48797 2.22591 8.56891C1.49654 9.38578 1.05904 10.428 0.991537 11.5208C0.903099 12.9564 1.42841 14.3211 2.44716 15.328C2.59685 15.4758 2.75404 15.613 2.91841 15.7395C3.79185 16.4117 4.85966 16.7761 5.98435 16.7761C6.23841 16.7761 6.48966 16.7573 6.73654 16.7208C7.78716 16.5652 8.75654 16.0842 9.52154 15.328C10.4615 14.3989 10.9809 13.1655 10.9865 11.8527L10.9731 6.02266C11.4215 6.36859 11.9118 6.65484 12.4381 6.87703C13.2565 7.22234 14.1243 7.39734 15.0175 7.39703V5.50297V4.80016C15.0181 4.80078 15.0106 4.80078 15.01 4.80078Z"
          fill="white"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1253_2246">
          <rect fill="white" height="16" transform="translate(0 0.788086)" width="16"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

export default LegacyTiktokIcon;
